import { createContext } from "react";

export const LogsContext = createContext([]);
